import { Text } from 'components';
import React from 'react';
import { TableComponents } from 'screens/Admin/components';
import { ListItem } from './';

const List = ({ data, onClick, onDelete, dataId, loading }) => {
  return (
    <TableComponents.List
      loading={loading || !data}
      Header={() => (
        <React.Fragment>
          <TableComponents.Th first>
            <Text>Owner</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Sport</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Shoutout For</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Team or Athlete</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Media type</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Published At</Text>
          </TableComponents.Th>
          <TableComponents.Th last>
            <Text>Actions</Text>
          </TableComponents.Th>
        </React.Fragment>
      )}
      Items={() =>
        !loading && data
          ? data.map((item, i) => (
              <ListItem
                key={item._id || i}
                dataId={dataId}
                onClick={onClick}
                onDelete={onDelete}
                item={item}
              />
            ))
          : null
      }
    />
  );
};

export default List;
